var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { computed, ref, watch } from 'vue';
import { validateEmail } from '@mumble/helpers';
import { validateAlpha, validateCommaFloat, validatePassword } from '../utils/helpers';
import { validationLocales } from '../utils/validation-locales';
export default function useValidations(objToValidate, validations, options) {
    if (options === void 0) { options = {}; }
    var locale = options.locale || 'en';
    var form = ref(__assign({}, objToValidate));
    var objKeys = Object.keys(objToValidate);
    var data = {};
    objKeys.forEach(function (key) {
        data[key] = false;
    });
    var hasPropertyChanged = ref(data);
    var errors = computed(function () {
        var errors = {};
        for (var key in validations) {
            var validation = validations[key];
            // @ts-ignore
            var value = form.value[key];
            var required = validation.required, isEmail = validation.isEmail, isPassword = validation.isPassword, isNumber = validation.isNumber, isCommaFloat = validation.isCommaFloat, isAlpha = validation.isAlpha, maxLength = validation.maxLength, minLength = validation.minLength, exactLength = validation.exactLength, confirm_1 = validation.confirm, confirmLabel = validation.confirmLabel, custom = validation.custom;
            if (isEmail && value && !validateEmail(value)) {
                errors[key] = validationLocales[locale].email;
            }
            if (isPassword && value && !validatePassword(value)) {
                errors[key] = validationLocales[locale].password;
            }
            if (isNumber && value && isNaN(value)) {
                errors[key] = validationLocales[locale].number;
            }
            if (isCommaFloat && value && !validateCommaFloat(value)) {
                errors[key] = validationLocales[locale].number;
            }
            if (minLength && value && (value === null || value === void 0 ? void 0 : value.length) < minLength) {
                errors[key] = validationLocales[locale].minLength(minLength);
            }
            if (maxLength && (value === null || value === void 0 ? void 0 : value.length) > maxLength) {
                errors[key] = validationLocales[locale].maxLength(maxLength);
            }
            // @ts-ignore
            if (confirm_1 && value !== form.value[confirm_1]) {
                errors[key] = validationLocales[locale].confirm(confirmLabel !== null && confirmLabel !== void 0 ? confirmLabel : confirm_1);
            }
            if (required && !value) {
                errors[key] = validationLocales[locale].required;
            }
            if (exactLength && value && (value === null || value === void 0 ? void 0 : value.length) !== exactLength) {
                errors[key] = validationLocales[locale].exactLength(exactLength);
            }
            if (isAlpha && value && !validateAlpha(value)) {
                errors[key] = validationLocales[locale].alphabetical;
            }
            if (custom && value && !custom.validator(value)) {
                errors[key] = validationLocales[locale].custom(custom.message);
            }
        }
        return errors;
    });
    var clear = function () {
        for (var key in objToValidate) {
            // @ts-ignore
            form.value[key] = objToValidate[key];
            // @ts-ignore
            hasPropertyChanged.value[key] = false;
        }
    };
    var errorsToShow = computed(function () {
        return Object.keys(errors.value)
            // @ts-ignore
            .filter(function (key) { return hasPropertyChanged.value[key]; })
            .reduce(function (cur, key) {
            var _a;
            return Object.assign(cur, (_a = {}, _a[key] = errors.value[key], _a));
        }, {});
    });
    var hasErrors = computed(function () { return !!Object.keys(errors.value).length; });
    watch(form, function (value) {
        for (var key in value) {
            if (value[key]) {
                // @ts-ignore
                hasPropertyChanged.value[key] = true;
            }
        }
    }, {
        deep: true,
    });
    return {
        form: form,
        clear: clear,
        errors: errorsToShow,
        errorsAll: errors,
        hasErrors: hasErrors,
    };
}
